/* eslint-disable import/no-extraneous-dependencies */
import axios from 'axios';

export default axios.create({
  baseURL: 'https://good-bye-be-test.herokuapp.com',
  headers: {
    'Content-type': 'application/json',
  },
});
